import {
  CommonModule
} from '@angular/common';

import {
  NgModule
} from '@angular/core';

import {
  FormsModule, ReactiveFormsModule
} from '@angular/forms';


import {
  RouterModule
} from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

const ANGULAR_MATERIAL_COMPONENTS = [
  MatInputModule,
  MatCheckboxModule,
  MatRippleModule,
  MatButtonModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatMenuModule,
  MatSelectModule,
  MatTabsModule,
  MatListModule,
  MatTooltipModule,
  MatSlideToggleModule,
  MatToolbarModule,
  MatRadioModule,
  MatDialogModule
];

export const CHILD_MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  HttpClientModule,

  ...ANGULAR_MATERIAL_COMPONENTS,
];

// import {
//   AuthHttp,
//   AuthConfig
// } from 'angular2-jwt';

import {

} from '@auth0/angular-jwt'

import {HttpClient, HttpClientModule} from "@angular/common/http";

// https://github.com/auth0/angular2-jwt/issues/158

// export function authFactory(http: Http, options: RequestOptions) {
//   return new AuthHttp(new AuthConfig({
//     // Config options if you want
//   }), http, options);
// }

// export const authProvider = {
//   provide: AuthHttp,
//   deps: [HttpClient, RequestOptions],
//   useFactory: authFactory
// };

@NgModule({
  imports: [
    ...CHILD_MODULES,
  ],
  declarations: [
  ],
  exports: [
    ...CHILD_MODULES,
  ],
  providers: [
  ]
})
export class SharedCommonModule {
  constructor(private _mdIconRegistry: MatIconRegistry) {
    _mdIconRegistry.registerFontClassAlias('fontawesome', 'fa');
  }
}
